export enum ProjectsSelectedFilter {
  COLLABORATORS = 'collaborators',
  DEPARTMENTS = 'departments',
  DROPOFF_SITES = 'dropoffSites',
  FOREMEN = 'foremen',
  MATERIALS = 'materials',
  PICKUP_SITES = 'pickupSites',
  REQUESTERS = 'requesters',
  SALESPERSONS = 'salespersons',
}

type ProjectsFilterKey =
  | 'collaboratorIds'
  | 'departmentIds'
  | 'dropoffSiteIds'
  | 'foremanIds'
  | 'materialIds'
  | 'pickupSiteIds'
  | 'requesterIds'
  | 'salespersonIds';

export const projectsFilterKeyBySelectedFilter: Record<
  ProjectsSelectedFilter,
  ProjectsFilterKey
> = {
  [ProjectsSelectedFilter.COLLABORATORS]: 'collaboratorIds',
  [ProjectsSelectedFilter.DEPARTMENTS]: 'departmentIds',
  [ProjectsSelectedFilter.DROPOFF_SITES]: 'dropoffSiteIds',
  [ProjectsSelectedFilter.FOREMEN]: 'foremanIds',
  [ProjectsSelectedFilter.MATERIALS]: 'materialIds',
  [ProjectsSelectedFilter.PICKUP_SITES]: 'pickupSiteIds',
  [ProjectsSelectedFilter.REQUESTERS]: 'requesterIds',
  [ProjectsSelectedFilter.SALESPERSONS]: 'salespersonIds',
};
